// Small enhancements for the sign-in pages. Safe to run more than once: AjaxCom
// swaps #content in place, so init() is called again after each swap.

const BOUND = 'authUiBound';

function initPasswordToggles(root) {
    root.querySelectorAll('[data-password-toggle]').forEach((button) => {
        if (button.dataset[BOUND]) return;
        button.dataset[BOUND] = '1';

        button.addEventListener('click', () => {
            const input = document.getElementById(button.getAttribute('aria-controls'));
            if (!input) return;

            const show = input.type === 'password';
            input.type = show ? 'text' : 'password';
            button.setAttribute('aria-pressed', String(show));
            button.setAttribute('aria-label', show ? 'Hide password' : 'Show password');
            button.querySelector('[data-icon="show"]').hidden = show;
            button.querySelector('[data-icon="hide"]').hidden = !show;
            input.focus();
        });
    });
}

function startLoading(button) {
    if (button.classList.contains('is-loading')) return;

    button.classList.add('is-loading');
    button.setAttribute('aria-busy', 'true');
    const spinner = document.createElement('span');
    spinner.className = 'auth-spinner';
    spinner.setAttribute('aria-hidden', 'true');
    button.appendChild(spinner);
}

function resetLoading(root) {
    root.querySelectorAll('.auth-submit.is-loading').forEach((button) => {
        button.classList.remove('is-loading');
        button.removeAttribute('aria-busy');
        button.querySelectorAll('.auth-spinner').forEach((spinner) => spinner.remove());
    });
    root.querySelectorAll('form[data-auth-submitting]').forEach((form) => {
        delete form.dataset.authSubmitting;
    });
}

function initSubmitButtons(root) {
    root.querySelectorAll('form').forEach((form) => {
        const button = form.querySelector('button.auth-submit');
        if (!button || form.dataset[BOUND]) return;
        form.dataset[BOUND] = '1';

        form.addEventListener('submit', (event) => {
            // Ignore repeat presses while the first submission is in flight.
            if (form.dataset.authSubmitting) {
                event.preventDefault();
                return;
            }
            form.dataset.authSubmitting = '1';
            startLoading(button);
        });
    });
}

function initCodeInputs(root) {
    root.querySelectorAll('[data-auth-code]').forEach((input) => {
        if (input.dataset[BOUND]) return;
        input.dataset[BOUND] = '1';

        const keepDigits = (value) => value.replace(/\D/g, '').slice(0, 6);

        input.addEventListener('input', () => {
            const digits = keepDigits(input.value);
            if (digits !== input.value) input.value = digits;
        });

        // Accept codes pasted with spaces or dashes ("123 456"), which maxlength would otherwise cut short.
        input.addEventListener('paste', (event) => {
            const text = (event.clipboardData || window.clipboardData).getData('text');
            event.preventDefault();
            input.value = keepDigits(text);
        });
    });
}

export default {
    init(root = document) {
        initPasswordToggles(root);
        initSubmitButtons(root);
        initCodeInputs(root);
    },

    resetLoading(root = document) {
        resetLoading(root);
    },
};
